import * as bootstrap from "bootstrap";

jQuery(document).ready(function($) {
    $(document).on('click', '.notify-hide', function () {
        $.get($(this).attr('href'));
        $(this).parents('.notification').remove();
        return false;
    });

    $('#notify_button').on('click', function () {
        if ($(this).attr('aria-expanded') === 'true') {
            $('.notification').each(function () {
                if (!$(this).data('read')) {
                    $.get('/notification/' + $(this).data('id') + '/read', function (r) {
                        console.log(r);
                    });
                }
                $('#notify_icon').removeClass('bi-bell-fill').addClass('bi-bell');
                $('#notify_count').text(0).removeClass('text-danger');
            });
        }
    });
});
